export var VehicleTypeFlags;
(function (VehicleTypeFlags) {
    VehicleTypeFlags[VehicleTypeFlags["CAR"] = 1] = "CAR";
    VehicleTypeFlags[VehicleTypeFlags["TRUCK"] = 3] = "TRUCK";
    VehicleTypeFlags[VehicleTypeFlags["VAN"] = 4] = "VAN";
    VehicleTypeFlags[VehicleTypeFlags["SUV"] = 5] = "SUV";
    VehicleTypeFlags[VehicleTypeFlags["MOTORCYCLE"] = 21] = "MOTORCYCLE";
    VehicleTypeFlags[VehicleTypeFlags["ATV"] = 22] = "ATV";
    VehicleTypeFlags[VehicleTypeFlags["RUV"] = 32] = "RUV";
    VehicleTypeFlags[VehicleTypeFlags["SNOWMOBILE"] = 30] = "SNOWMOBILE";
    VehicleTypeFlags[VehicleTypeFlags["GENERICVEHICLE"] = 50] = "GENERICVEHICLE";
    VehicleTypeFlags[VehicleTypeFlags["COMMERCIAL_HEAVYTRUCK"] = 38] = "COMMERCIAL_HEAVYTRUCK";
    VehicleTypeFlags[VehicleTypeFlags["COMMERCIAL_MEDIUMTRUCK"] = 39] = "COMMERCIAL_MEDIUMTRUCK";
    VehicleTypeFlags[VehicleTypeFlags["COMMERCIAL_TRAILER"] = 40] = "COMMERCIAL_TRAILER";
    VehicleTypeFlags[VehicleTypeFlags["GENERIC_COMMERCIAL"] = 999] = "GENERIC_COMMERCIAL";
})(VehicleTypeFlags || (VehicleTypeFlags = {}));
//# sourceMappingURL=VehicleTypeFlags.js.map